<template>
  <transition name="slide">
    <div
      id="screen"
      :class="{
        subscriberVideoDisabled: isSubscriberVideoOff,
        'screen-sharing-on': screenShareOn,
        backgroundBlur: fullScreenValue
      }"
      @error="errorHandler"
      class="d-flex"
    >
      <!-- only site team member can access the recording button -->
      <TeleHealthRecording style="position:absolute;" v-if="isSiteTeamAccess" :screenShareOn="screenShareOn" :recordingOptions="recordingOptions" :session="session" :stream="streams" :sessionDetails="tokensNKeys"></TeleHealthRecording>
      <div class="video-container" v-show="!screenShareOn">
        <div id="end-call" v-if="askEndCallConfirmation && !screenShareOn">
          <div id="end-call-content">
            <div class="mb-15">Are you sure you want to end the call?</div>
            <button type="button" @click="hangUp" class="btn btn-danger btn-sm btn-block">
              End call
            </button>
            <button type="button" @click="cancelEndCall" class="btn btn-secondary btn-sm btn-block">
              Cancel
            </button>
          </div>
        </div>
        <div class="membersMainDiv" v-if="addMembersOpen" :style="[videoStreams.length <= 2 && !fullScreenValue ? { height: '68vh' } : { height: '47vh' }, fullScreenValue ? { height: '68vh' } : {}]">
          <div class="membersDiv" :style="[fullScreenValue ? { width: '40%' } : {}]">
            <div class="membersInnerDiv">
              <div class="row membersHeader fs-13">
                <div class="col-6 pt-6 pb-6" style="border-right:2px solid #ffffff;">
                  Name
                </div>
                <div class="col-6 pt-6 pb-6">Role<span class="fa fa-times pull-right cursor_pointer" @click="addMembers"></span></div>
              </div>
              <div class="membersList">
                <div class="row pt-2 pb-2" v-for="(member, index) in teamMembers" :key="index">
                  <div class="col-6">
                    <label class="">
                      <input type="checkbox" v-model="member.invitedInTelehealthVisit" />
                      <span>&nbsp;{{ member.firstName }}&nbsp;{{ member.lastName }}</span>
                    </label>
                  </div>
                  <div class="col-6 fs-12">
                    <span v-if="member.userRole == 'Pi'">Principal Investigator</span>
                    <span v-if="member.userRole == 'SubPi'">Sub-Investigator</span>
                    <span v-if="member.userRole == 'StudyCoordinator'">Study Coordinator</span>
                    <span v-if="member.userRole == 'HomeHealth'">Home Health</span>
                    <span v-if="member.userRole == 'SiteDataLock'">Site - Data Lock</span>
                    <span v-if="member.userRole == 'CallCenter'">Call Center</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="btnDiv">
              <button class="btn add" @click="addMembersToCall">
                Add Members
              </button>
            </div>
          </div>
        </div>
        <div class="streams">
          <div
            class="streamDiv"
            :style="[
              videoStreams.length > 4 && !fullScreenValue ? { width: streamWidth + 'vw!important' } : {},
              videoStreams.length === 1 && !fullScreenValue && participantJoined
                ? {
                    margin: '2vh 0 0 12vw',
                    'border-radius': '4px',
                    'z-index': '999',
                    border: 'none!important'
                  }
                : {}
            ]"
          >
            <publisher :session="session" @error="errorHandler" :opts="options" :enableAudio="publishMicAudio" :enableVideo="publishVideo" :endCall="endVideoCall" :stream="streams" :apiTokensResponse="tokensNKeys" :screenShare="screenShareValue" :changeMode="changeModeValue" @sharingStopped="videoChange" @videoStopped="screenSharing"></publisher>
          </div>
          <div
            v-for="stream in streams"
            :key="stream.streamId"
            :class="{
              displayNone: stream.display && stream.display === 'none',
              participantClass: stream.videoType === 'screen' || (screenShareIndex === -1 && stream.role === 'Participant'),
              onlyParticipantClass: stream.role === 'Participant',
              participantFullScreen: (stream.videoType === 'screen' || (screenShareIndex === -1 && stream.role === 'Participant')) && fullScreenValue
            }"
            :style="[
              stream.videoType === 'screen' || (screenShareIndex === -1 && stream.role === 'Participant') ? (videoStreams.length <= 2 ? { height: '68vh' } : { height: '47vh' }) : {},
              !(stream.videoType === 'screen' || (screenShareIndex === -1 && stream.role === 'Participant')) && videoStreams.length > 4 && !fullScreenValue ? { width: streamWidth + 'vw!important' } : {},
              videoStreams.length === 1 && !fullScreenValue && participantJoined ? { height: '100%!important' } : {}
            ]"
            class="streamDiv"
          >
            <subscriber @error="errorHandler" @streamSatus="onStreamSatusUpdate" @videoDisabled="onVideoDisabled" @enableBlockedAudio="enableBrowserDisabledAudio" :stream="stream" :session="session" :opts="stream.options" :enableSpeaker="publishSpeakerAudio"></subscriber>
          </div>
        </div>
        <div class="button-controls" :class="{ 'full-view': screenShareOn }">
          <div title="Toggle Microphone" @click="toggleMic" :class="[publishMicAudio ? 'mic-btn' : 'mic-btn-off', 'btn-set']" class="ml-10"></div>
          <div title="Toggle Speaker" @click="toggleSpeaker" :class="[publishSpeakerAudio ? 'speaker-btn' : 'speaker-btn-off', 'btn-set']" class="ml-13"></div>
          <div title="Toggle Video" @click="toggleVideo" :class="[publishVideo ? 'video-btn' : 'video-btn-off', 'btn-set']"></div>
          <div title="Leave Meeting" @click="showEndCallConfrimation" class="btn-set hang-up"></div>
          <div title="Add Members" @click="addMembers" :class="[addMembersOpen ? 'add-btn-off' : 'add-btn', 'btn-set']" :style="[!callConnected ? { cursor: 'not-allowed!important' } : {}]"></div>
          <div v-if="callConnected" title="Screen Share" @click="videoChange" :class="[screenShareOn ? 'share-btn-off' : 'share-btn', 'btn-set']"></div>
          <div title="Full Screen" @click="toggleFullScreen" :class="[fullScreenValue ? 'full-screen-off' : 'full-screen', 'btn-set']"></div>
        </div>
        <div class="stream-status-container align-self-center text-center">
          <div class="spinner" v-if="waiting">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
          </div>
          {{ streamStatusTxt }}
        </div>
        <div id="preloadBtnImages">
          <img alt="mute-mic" src="/static/img/video-call/mute-mic.png" />
          <img alt="speaker-off" src="/static/img/video-call/speaker-off.png" />
        </div>
        <!-- show when screen sharing is enabled -->
        <div id="end-call" class="full-view" v-if="askEndCallConfirmation && screenShareOn">
          <div id="end-call-content" class="full-view">
            <div class="mb-15">Are you sure you want to end the call?</div>
            <button type="button" @click="hangUp" class="btn btn-danger btn-sm btn-block">
              End call
            </button>
            <button type="button" @click="cancelEndCall" class="btn btn-secondary btn-sm btn-block">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import toastr from "toastr";
import moment from "moment";
import _ from "lodash";
import OT from "@opentok/client";
import Publisher from "./Publisher.vue";
import Subscriber from "./Subscriber.vue";
import TeleHealthRecording from "./tele-health-recording.vue";
import { mapGetters } from "vuex";
import { PI, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, INTERVIEWER, CC } from "@/constants/authRoles";
import { AclRule } from "vue-acl";
import LocalStorageService from "../../services/localStorage";

export default {
  name: "session",
  data: () => ({
    streams: [],
    session: null,
    options: {
      insertMode: "append",
      width: "100%",
      height: "100%",
      style: {
        buttonDisplayMode: "on",
        nameDisplayMode: "on",
        backgroundImageURI: "",
        audioBlockedDisplayMode: "off"
      }
    },
    streamStatusTxt: "Waiting for your participant to join",
    publishMicAudio: true,
    publishSpeakerAudio: true,
    endVideoCall: false,
    waiting: true,
    isSubscriberVideoOff: false,
    askEndCallConfirmation: false,
    screenShareValue: "",
    screenShareOn: false,
    callConnected: false,
    changeModeValue: false,
    addMembersOpen: false,
    appointmentId: "",
    screenShareIndex: -1,
    publishVideo: true,
    videoStreams: [],
    streamWidth: 0,
    fullScreenValue: false,
    teamMembers: [],
    participantJoined: false,
    tempTeam: []
  }),
  computed: {
    ...mapGetters(["user", "getVideoCallStatus"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPIAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canInterviewerAccess() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    isSiteTeamAccess() {
      return this.canHomeHealthAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.canInterviewerAccess || this.canCallCenterAccess;
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    }
  },
  watch: {
    getVideoCallStatus(callInProgress) {
      this.isCallInProgress = callInProgress;
    }
  },
  components: { Publisher, Subscriber, TeleHealthRecording },
  props: {
    sessionId: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    apiKey: {
      type: String,
      required: true
    },
    tokensNKeys: {
      required: true,
      type: Object
    },
    callObject: {
      required: true,
      type: Object
    },
    recordingOptions: {
      required: true,
      type: Object
    }
  },
  created() {
    const self = this;
    this.session = OT.initSession(this.apiKey, this.sessionId);
    if (this.session) {
      this.session.connect(this.token, err => {
        if (err) {
          this.errorHandler(err);
        }

        //Emit an event to notify that video call session has been created
        this.$root.$emit("videoCallSessionConnected");
      });

      this.session.on("streamCreated", event => {
        this.callConnected = true;
        this.waiting = false;
        this.streamStatusTxt = "";
        event.stream.options = this.options;
        const data = event.stream.connection.data;
        const dataArray = data.split(";");
        const name = dataArray[2].split("=")[1];
        const role = dataArray[1].split("=")[1];
        event.stream.role = role;
        const nameWithRole = name + " | " + role;
        event.stream.name = nameWithRole;
        if (role === "Participant") {
          //Participant has joined the meeting
          this.$root.$emit("subcriberJoined");
          this.participantJoined = true;
        }
        if (event.stream.videoType === "screen") {
          const sameConnectionIndex = _.findIndex(this.streams, stream => stream.connection.connectionId === event.stream.connection.connectionId);
          if (sameConnectionIndex !== -1) {
            this.streams[sameConnectionIndex].display = "none";
            const newa = this.streams[sameConnectionIndex];
            this.streams.splice(sameConnectionIndex, 1);
            this.streams.push(newa);
          }
        } else {
          this.videoStreams.push(event.stream);
          const videoStreamColumn = Math.ceil(this.videoStreams.length / 2);
          const avgVideoStreamColumn = 26 / videoStreamColumn;
          this.streamWidth = avgVideoStreamColumn - 0.2;
        }
        this.streams.push(event.stream);
        this.screenShareIndex = _.findIndex(this.streams, stream => stream.display === "none");

        const sessionId = event.target.sessionId;
        const callStartTime = moment.utc().valueOf();
        const pId = self.user.id;
        //Call an API to update the call start time
        self.$api.updateTelehealthCallStartTime(sessionId, callStartTime, pId).then(
          () => {},
          error => {
            toastr.error(error.body && error.body.message ? error.body.message : "Error while updating the call time!");
          }
        );
      });

      this.session.on("streamDestroyed", event => {
        if (this.streams.length === 1) {
          if (self.session.isConnected()) {
            self.session.disconnect();
            //Emit an event to hide/end the video call component
            self.$root.$emit("videoCallEnded");
            toastr.error("This meeting has been ended");
            document.location.reload();
          }
          const idx = this.streams.indexOf(event.stream);
          if (idx > -1) {
            this.streams.splice(idx, 1);
          }
        } else {
          if (event.stream.role === "Participant") {
            this.participantJoined = false;
          }
          if (event.stream.videoType === "screen") {
            const findStreamIndex = _.findIndex(this.streams, stream => stream.display === "none");
            if (findStreamIndex !== -1) {
              this.streams[findStreamIndex].display = "block";
            }
            this.screenShareIndex = -1;
          }
          const idx = this.streams.indexOf(event.stream);
          if (idx > -1) {
            this.streams.splice(idx, 1);
          }
          const index = this.videoStreams.indexOf(event.stream);
          if (index > -1) {
            this.videoStreams.splice(index, 1);
          }
        }
      });
    }
  },
  methods: {
    toggleMic() {
      this.publishMicAudio = !this.publishMicAudio;
    },
    toggleSpeaker() {
      this.publishSpeakerAudio = !this.publishSpeakerAudio;
    },
    toggleVideo() {
      this.publishVideo = !this.publishVideo;
    },
    toggleFullScreen() {
      this.fullScreenValue = !this.fullScreenValue;
      this.$root.$emit("fullScreen", this.fullScreenValue);
    },
    hangUp() {
      this.endVideoCall = true;
      this.screenShareOn = false;
      this.cancelEndCall();
    },
    showEndCallConfrimation() {
      this.addMembersOpen = false;
      this.askEndCallConfirmation = true;
    },
    cancelEndCall() {
      this.askEndCallConfirmation = false;
    },
    onStreamSatusUpdate(streamStatus) {
      this.waiting = false;
      this.streamStatusTxt = streamStatus;
    },
    onVideoDisabled(videoValue) {
      this.isSubscriberVideoOff = videoValue;
    },
    enableBrowserDisabledAudio() {
      if (this.publishSpeakerAudio) {
        OT.unblockAudio();
      }
    },
    videoChange() {
      let screenShareStreams = [];
      screenShareStreams = _.filter(this.streams, stream => stream.videoType === "screen");
      if (screenShareStreams.length !== 0) {
        toastr.error("The current screen sharing has to be stopped");
      } else {
        this.changeModeValue = true;
        if (this.screenShareValue === "") {
          this.screenShareValue = "screen";
        } else if (this.screenShareValue === "screen") {
          this.screenShareValue = "video";
        } else {
          this.screenShareValue = "screen";
        }
      }
    },
    screenSharing(value) {
      this.screenShareOn = value;
      this.changeModeValue = false;
      if (value) {
        this.screenShareValue = "screen";
        // when screen is enabled then hide the th side panel for that emit the event
        LocalStorageService.setItem("isScreenSharingEnabled", true);
        this.$root.$emit("screenSharingStarted", true);
      } else {
        // when screen is disabled then show the th side panel for that emit the event
        LocalStorageService.setItem("isScreenSharingEnabled", false);
        this.$root.$emit("screenSharingEnded", false);
        this.screenShareValue = "video";
        this.fullScreenValue = false;
      }
    },
    errorHandler(err) {
      if (err.name == "OT_USER_MEDIA_ACCESS_DENIED" && this.screenShareValue !== "") {
        toastr.error("Screen sharing has been declined");
        this.screenShareValue = "video";
        this.changeModeValue = false;
      } else if (err.name == "OT_USER_MEDIA_ACCESS_DENIED") {
        toastr.warning("Please grant access to camera and microphone in order to start the call");
      } else if (err.name === "OT_NOT_CONNECTED") {
        toastr.warning("You are not connected to the internet. Check your network connection.");
      } else {
        toastr.error(err.message);
      }
    },
    addMembers() {
      if (this.callConnected) {
        this.addMembersOpen = !this.addMembersOpen;
        if (this.addMembersOpen) {
          this.$api.getResearchTeamMembersFact(this.$route.params.studyId, this.siteId, this.appointmentId).then(
            response => {
              const data = _.filter(response.body, member => member.id !== this.user.id && member.userRole.toLowerCase() !== "rater");
              this.teamMembers = data;
              this.tempTeam = _.cloneDeep(data);
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting research team members.");
            }
          );
        }
      }
    },
    addMembersToCall() {
      const selectedTeamMembers = _.filter(this.teamMembers, member => member.invitedInTelehealthVisit === true);
      const selectedTempTeam = _.filter(this.tempTeam, member => member.invitedInTelehealthVisit === true);
      const teamNotInCall = [];
      selectedTeamMembers.forEach(member => {
        if (_.filter(selectedTempTeam, tempMember => tempMember.id === member.id).length === 0) {
          teamNotInCall.push(member);
        }
      });
      if (selectedTeamMembers.length === 0 || teamNotInCall.length === 0) {
        this.$toastr.error("Please select members to add to this call.");
      } else {
        this.$api.addMembersToCallFact(this.appointmentId, this.$route.params.studyId, this.siteId, teamNotInCall).then(
          response => {
            this.addMembersOpen = false;
            this.$toastr.success(response.bodyText);
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding research team members.");
          }
        );
      }
    }
  },
  mounted() {
    this.appointmentId = window.localStorage.getItem("thread-currentCallId");
    this.siteId = this.user.siteIds ? this.user.siteIds[0] : null;
  }
};
</script>

<style lang="scss">
#video-chat-session {
  background: #000;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
  color: #ffffff;
  bottom: 0;
  &.screen-sharing-on {
    background: none;
    height: 0;
  }
}
.button-controls {
  background: #353b4a;
  color: #000;
  padding: 20px 0;
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
  &.full-view {
    background: rgba(45, 55, 82, 0.7);
  }
}
.button-controls .btn-set {
  display: inline-block;
  cursor: pointer;
  margin-left: 20px;
}

#preloadBtnImages {
  position: absolute;
  top: -5000px;
  background: url("/static/img/telehealth/mute.png") no-repeat -9999px -9999px;
  background: url("/static/img/telehealth/mute.png") no-repeat -9999px -9999px, url("/static/img/telehealth/speker.png") no-repeat -9999px -9999px;
}
.small-screen {
  background: url(/static/img/telehealth/smallscreen.png) no-repeat;
  width: 40px;
  height: 36px;
  border: none !important;
  border-radius: 0 !important;
}

.mic-btn {
  background: url("/static/img/video-call/mic.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") 11px 0 no-repeat; */
  width: 35px;
  height: 35px;
}

.mic-btn-off {
  background: url("/static/img/video-call/mic-off.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -31px 0 no-repeat; */
  width: 35px;
  height: 35px;
}

.speaker-btn {
  background: url("/static/img/video-call/speaker.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -73px 0 no-repeat; */
  width: 35px;
  height: 35px;
}

.speaker-btn-off {
  background: url("/static/img/video-call/speaker-off.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -115px 0 no-repeat; */
  width: 35px;
  height: 35px;
}

.share-btn {
  background: url("/static/img/video-call/screen-share.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -73px 0 no-repeat; */
  width: 40px;
  height: 42px;
}

.share-btn-off {
  background: url("/static/img/video-call/screen-share-off.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -73px 0 no-repeat; */
  width: 40px;
  height: 42px;
}

.full-screen {
  background: url("/static/img/video-call/full-screen.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -73px 0 no-repeat; */
  width: 35px;
  height: 35px;
}

.full-screen-off {
  background: url("/static/img/video-call/full-screen-off.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -73px 0 no-repeat; */
  width: 35px;
  height: 35px;
}

.video-btn {
  background: url("/static/img/video-call/video.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -73px 0 no-repeat; */
  width: 35px;
  height: 35px;
}

.video-btn-off {
  background: url("/static/img/video-call/video-off.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -73px 0 no-repeat; */
  width: 35px;
  height: 30px;
}

.add-btn {
  background: url("/static/img/video-call/add-members.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -73px 0 no-repeat; */
  width: 35px;
  height: 38px;
}

.add-btn-off {
  background: url("/static/img/video-call/add-members-off.png") no-repeat;
  /* background: url("/static/img/video-call/btn-sprite.svg") -73px 0 no-repeat; */
  width: 35px;
  height: 38px;
}

.hang-up {
  background: url("/static/img/video-call/hang-up.png") no-repeat;
  width: 40px;
  height: 41px;
  background-size: cover;
  border: 0 !important;
}

.stream-status-container {
  width: 100%;
  position: absolute;
  top: 25%;
}

#video-chat-session.subscriberVideoDisabled .stream-status-container {
  z-index: 1;
}

#video-chat-session.subscriberVideoDisabled .OT_video-poster {
  z-index: inherit;
}

#video-chat-session.subscriberVideoDisabled .OT_audio-level-meter__audio-only-img {
  display: none;
}

.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

/*Waiting for Participant Loader Css*/
.spinner {
  width: 40px;
  height: 40px;
  position: relative;
  margin: 0 auto;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #fff;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
/*Waiting for Participant Loader Ends*/
#end-call {
  position: absolute; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  background-color: rgba(105, 105, 105, 0.7); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
  &.full-view {
    position: fixed;
    bottom: 57%;
    left: 50%;
    width: auto;
    height: auto;
  }
}
#end-call-content {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 16px;
  color: white;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
  &.full-view {
    background: rgba(45, 55, 82, 0.7);
    width: 333px;
    height: 165px;
    padding: 29px;
    border-radius: 3px;
  }
}

#screen {
  background: #000;
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 999;
  color: #ffffff;
  flex: 1;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: row;
}

.membersMainDiv {
  position: absolute; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  bottom: 85px;
  background-color: rgba(105, 105, 105, 0.7); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
}

.membersDiv {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 90%;
  width: 90%;
  font-size: 14px;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 12px;
}

.membersInnerDiv {
  color: #000000;
  height: 85%;
}

.membersHeader {
  background-color: #e4e8eb;
  border-radius: 12px 12px 0 0;
}

.membersList {
  overflow-y: scroll;
  height: 88%;
  border-bottom: 1px solid black;
  padding-top: 10px;
  margin-right: 2px;
}

.membersList::-webkit-scrollbar {
  width: 7px;
  padding: 2px;
}

.membersList::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 5px;
}

.btnDiv {
  text-align: center;
  padding: 5px 0;
}

.add {
  background-color: #1e8fe1;
  color: #ffffff;
  width: 45%;
}

.OT_publisher .OT_edge-bar-item.OT_mode-off,
.OT_subscriber .OT_edge-bar-item.OT_mode-off,
.OT_publisher .OT_edge-bar-item.OT_mode-auto,
.OT_subscriber .OT_edge-bar-item.OT_mode-auto,
.OT_publisher .OT_edge-bar-item.OT_mode-mini-auto,
.OT_subscriber .OT_edge-bar-item.OT_mode-mini-auto {
  bottom: 0 !important;
  opacity: 1;
  top: initial !important;
}

.OT_publisher .OT_mute {
  display: none !important;
}

.OT_subscriber .OT_mute {
  bottom: 10px !important;
  left: 10px !important;
  top: initial !important;
  background-image: url("/static/img/video-call/speaker.png") !important;
  background-position: 0 !important;
  display: block !important;
  border-left: none !important;
}

.OT_subscriber .OT_mute.OT_active {
  background-image: url("/static/img/video-call/mute-on.png") !important;
  background-position: 0 !important;
}

.OT_subscriber .OT_name {
  right: 0 !important;
  background-color: rgba(74, 74, 74, 0.8) !important;
  font-size: 12px;
  color: #f2f2f2 !important;
  padding: 5px 10px;
}

.OT_publisher .OT_bar,
.OT_subscriber .OT_bar,
.OT_publisher .OT_name,
.OT_subscriber .OT_name,
.OT_publisher .OT_archiving,
.OT_subscriber .OT_archiving,
.OT_publisher .OT_archiving-status,
.OT_subscriber .OT_archiving-status,
.OT_publisher .OT_archiving-light-box,
.OT_subscriber .OT_archiving-light-box {
  bottom: 0 !important;
  top: initial !important;
  left: auto !important;
  padding: 7px 10px;
  height: auto !important;
  line-height: normal !important;
}

.onlyParticipantClass {
  .OT_subscriber .OT_mute,
  .OT_subscriber .OT_bar,
  .OT_subscriber .OT_name,
  .OT_subscriber .OT_archiving,
  .OT_subscriber .OT_archiving-status,
  .OT_subscriber .OT_archiving-light-box {
    display: none !important;
  }
}

.OT_publisher .OT_edge-bar-item.OT_mode-off,
.OT_publisher .OT_edge-bar-item.OT_mode-auto,
.OT_publisher .OT_edge-bar-item.OT_mode-mini-auto {
  display: none !important;
}

.OT_publisher .OT_bar,
.OT_publisher .OT_name,
.OT_publisher .OT_archiving,
.OT_publisher .OT_archiving-status,
.OT_publisher .OT_archiving-light-box {
  display: none !important;
}

.publisher {
  width: 200px !important;
  height: 200px !important;
  float: left;
}

.subscribers {
  float: left;
}

#screen {
  position: relative;
}

#screen ul {
  display: flex;
  flex: 1;
  flex-direction: row;
  list-style-type: none;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
}

#screen ul li {
  height: 200px;
  width: 200vw;
  display: inline-block;
  position: relative;
}

#screen .streams .listDiv {
  width: 100%;
  height: 100%;
  position: relative;
}

.participantClass {
  // height: calc(100% - 228px)!important;
  position: absolute !important;
  bottom: 85px;
  width: 100% !important;
  border: none !important;
}

.participantFullScreen {
  bottom: 110px !important;
  width: 50vw !important;
  margin-left: 25vw !important;
  border: 1px solid #000000 !important;
  height: 60vh !important;
}

.displayNone {
  display: none !important;
}

.streams {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: row;
  max-height: 100vh;
}

.streamDiv {
  width: 12.75vw;
  height: 21vh;
  border: 1px solid #000000;
}

.backgroundBlur {
  background-color: rgba(0, 0, 0, 0.6) !important;
}
</style>
